import { render, staticRenderFns } from "./PmLayout.vue?vue&type=template&id=1958573f&scoped=true&"
import script from "./PmLayout.vue?vue&type=script&lang=js&"
export * from "./PmLayout.vue?vue&type=script&lang=js&"
import style0 from "./PmLayout.vue?vue&type=style&index=0&id=1958573f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1958573f",
  null
  
)

component.options.__file = "PmLayout.vue"
export default component.exports